import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    onUpdateColumn,
    setOrder,
    setSelectedRow
} from '../../../store/movilidad/tracking/actions';

//from '../../store/movilidad/reportetracking/actions';

import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    }, 
    tableWrap: {
        flex: '1 1 auto'
    }
}));

const TrackingList = () => {
    const classes = useStyles();
    const columns = useSelector(state => state.tracking.table.columns);
    const loading = useSelector(state => state.tracking.store.loading);
    const order = useSelector(state => state.tracking.table.order);
    const orderBy = useSelector(state => state.tracking.table.orderBy);
    const store = useSelector(state => state.tracking.store);
    const dispatch = useDispatch();
    //console.log(store);
    //debbuger(store);
    
    const handleDoubleClick = (id) => {
        return;
        /*
        history.push({
            hash: location.hash,
            pathname: `/fuerzaventas/metas/${id}`,
            search: location.search
        });
        */
    }

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
    };

    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
 };
    
    return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
        <div className={classes.tableWrap}>
            <Table
                columns={columns}
                count={store.total}
                loading={loading}
                onRowClick={items => dispatch(setSelectedRow(items))}
                onRowDoubleClick={item => handleDoubleClick(item.usuarioId)}
                onSort={datakey => handleRequestSort(datakey)}
                onUpdateColumn={handleResizeColumn}
                rowCount={store.data.length}
                rowGetter={index => store.data[index]}
                selected={store.selected}
                sortBy={orderBy}
                sortDirection={order}
            />
        </div>
    </FieldSet>
    )
};

export default TrackingList;